
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { commonModule, actionTypesModule } from '@/store/modules/store-accessor'

  @Component
  export default class ToggleActiveActionTypeModal extends Vue {
    @Prop()
    payload!: any;
    isInActivatingType = false;

    async hideModal () {
      commonModule.hideModal();
    }

    async updateActionTypes() {
      await actionTypesModule.getAllActionTypes();
      this.hideModal()
    }

    async mounted() {
      commonModule.initSnackbar({});
    }

    async setChangeActive () {
        this.isInActivatingType = true;
        await actionTypesModule.editActionType(this.payload.actionType);
        await actionTypesModule.getAllActionTypes();
        this.hideModal()
    }
  };
